import RadioInputButton from "@components/RadioInputButton"
import { useTranslation } from "react-i18next"
import { twMerge } from "tailwind-merge"

interface UnitOption {
  value: string
  label: string
}

interface Props {
  value: string
  onChange: (value: string) => void
  unit: string
  onUnitChange: (unit: string) => void
  units: UnitOption[]
  placeholder?: string
}

export default function NumberInputWithUnit({
  value,
  onChange,
  unit,
  onUnitChange,
  units,
  placeholder = "",
}: Props) {
  const { t } = useTranslation()

  return (
    <>
      <div className="mx-auto mb-6 flex w-full max-w-xs overflow-hidden rounded-3xl border border-gray-300 bg-white">
        <input
          type="number"
          placeholder={placeholder}
          autoFocus
          value={value}
          onChange={(event) => onChange(event.target.value)}
          className="no-spinners w-2/3 bg-transparent px-4 py-6 text-center text-3xl outline-hidden focus:border-transparent focus:ring-0 focus:outline-hidden"
          style={{
            WebkitAppearance: "none",
            MozAppearance: "textfield",
            outline: "none",
            boxShadow: "none",
            border: "none",
          }}
        />
        <div className="flex w-1/3 items-center justify-center border-l border-gray-300">
          <span className="text-2xl font-semibold">{unit}</span>
        </div>
      </div>

      <div className="mx-auto mb-6 flex space-x-2">
        {units.map((unitOption) => (
          <RadioInputButton
            key={unitOption.value}
            variant="unit"
            checked={unit === unitOption.value}
            className={twMerge(
              "flex h-12 cursor-pointer items-center justify-center rounded-full px-6",
              unit === unitOption.value
                ? "border-custom-teal bg-custom-teal text-white"
                : "text-custom-charcoal border-gray-200 bg-white",
            )}
            label={t(unitOption.label)}
            name={undefined}
            value={unitOption.value}
            onChange={(event) => {
              event.preventDefault()
              onUnitChange(unitOption.value)
            }}
          />
        ))}
      </div>
    </>
  )
}
